/**
 * CampGetRes 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { CampData } from './camp_data'

/**
 * CampGetRes
 */
export interface CampGetRes {
  /** 大本营详情 */
  items?: CampData[]
}

/**
 * CampGetRes Schema
 */
export const CampGetResSchema: SchemaDefinition = {
  properties: {
    items: {
      description: '大本营详情',
      format: '[]*model.CampData',
      items: { $ref: 'CampData', description: '' },
      type: 'array',
      label: '大本营详情',
    },
  },
  type: 'object',
}
